export class Agencia{
    Id: number;
    Descricao:string = "";
    BancoId: number;

    EmpresaId: number;
    DataCadastro: Date = new Date();
    DataAlteracao: Date = new Date();
    UsuarioCadastroId: number;
    UsuarioAlteracaoId: number;
}
